import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface WorkflowRunsErrorStateProps {
  onRetry: () => void
}

export function WorkflowRunsErrorState({ onRetry }: WorkflowRunsErrorStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16"
      role="alert"
      data-testid="workflow-runs-error"
    >
      <AlertCircle className="h-12 w-12 text-destructive" />
      <h3 className="mt-4 text-lg font-semibold">Failed to load workflow runs</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Something went wrong while loading your workflow runs.
      </p>
      <Button onClick={onRetry} variant="outline" className="mt-4">
        Try Again
      </Button>
    </div>
  )
}
